// Where to go after signing in or up, for links shared outside the app
// (the name poll's /poll). Kept for this browser tab only.
const RETURN_KEY = "jangle:return-to";
export const NEW_FROM_POLL_KEY = "jangle:poll-new-player";

export function remember(key, value) {
  try { sessionStorage.setItem(key, value); } catch { /* ignore */ }
}

export function recall(key) {
  try { return sessionStorage.getItem(key); } catch { return null; }
}

export function forget(key) {
  try { sessionStorage.removeItem(key); } catch { /* ignore */ }
}

export function setReturnTo(path) {
  remember(RETURN_KEY, path);
}

// The saved path, once; only same-site paths.
export function takeReturnTo() {
  const p = recall(RETURN_KEY);
  forget(RETURN_KEY);
  return p && p.startsWith("/") && !p.startsWith("//") ? p : null;
}
